import { Api } from 'utils';

class ReportService {
	
	static admin = {
		getServices: async (params?: any) => Api.createResponse('admin/reports/services',params),
		downloadServices: async (params?: any) => Api.createResponse('admin/reports/download-services',params),
		getRecurring: async (params?: any) => Api.createResponse('admin/reports/recurring-services',params),
		downloadRecurring: async (params?: any) => Api.createResponse('admin/reports/download-recurring',params),
		getPlanning: async (params?: any) => Api.createResponse('admin/reports/planning',params),
		downloadPlanning: async (params?: any) => Api.createResponse('admin/reports/download-planning',params),
		getTypes: async (params?: any) => Api.createResponse('admin/reports/types',params),
		getSurveys: async (params?: any) => Api.createResponse('admin/reports/surveys',params),
	}

}

export default ReportService;